
























import Vue from "vue";
import NumberPad from "@/components/Money/NumberPad.vue";
import FormItem from "@/components/Money/FormItem.vue";
import Tags from "@/components/Money/Tags.vue";
import Tabs from "@/components/Tabs.vue";
import { Component } from "vue-property-decorator";
import recordTypeList from "@/constants/recordTypeList";
import day from "dayjs";

@Component({
  components: {
    NumberPad,
    Tabs,
    FormItem,
    Tags,
  },
})
export default class Money extends Vue {
  get recordList() {
    return this.$store.state.recordList;
  }
  recordTypeList = recordTypeList;
  record: RecordItem = {
    tags: [],
    notes: "",
    type: "-",
    amount: 0,
    createdAt: day(new Date()).format("YYYY-MM-DD"),
  };
  created() {
    this.$store.commit("fetchRecords");
  }

  saveRecord() {
    this.$store.commit("createRecord", this.record);
    this.record.notes = "";
    this.record.tags = [];
  }
}
